export default __webpack_public_path__ + "static/perfectring-4c46829b2d21ae5450c8e4740bc3a67f.png";